var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showComponent)?_c('div',[(_vm.showEditButton)?_c('font-awesome-icon',{staticClass:"clickable float-right",attrs:{"id":"font-awesome-icon-edit","icon":"edit","size":"sm"},on:{"click":function($event){return _vm.$emit('edit-button-clicked')}}}):_vm._e(),_c('hr')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }